module.exports = __webpack_public_path__ + "img/privatelayer_cn.cc94847.jpg";